import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import {MenuState} from "./reducer/menuReducer";


export const selectMenuItemsFeature = createFeatureSelector<MenuState>(StoreKeys.MENU_ITEMS);

export const selectMenuItemsDatas = createSelector(selectMenuItemsFeature, state => state.datas);
